/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when an Entity could not be added
 * @export
 * @class EntityCouldNotAddEntityError
 * @extends {Error}
 */
export class EntityCouldNotAddEntityError extends Error {
  /**
   * Creates an instance of EntityCouldNotAddEntityError
   * @param {string} message The Error `message`
   * @memberof EntityCouldNotAddEntityError
   */
  constructor(message) {
    super(message);
    this.name = `EntityCouldNotAddEntityError`;
  }
}

/**
 * Called when an Entity could not be added
 * @param {sting} id The `id` of the entity to add
 * @returns {never} never
 */
const throwEntityCouldNotAddEntityError = (id) => {
  throw new EntityCouldNotAddEntityError(
    stripIndent(`
    Can not add entity with id: "${id}".
    Entity already exists.
    Did you mean update?
    `),
  );
};

export default throwEntityCouldNotAddEntityError;
